import React, { useEffect, useState } from 'react'
import { useRetorik } from '../Contexts/RetorikContext'
import { fetchEmergencyData } from '../../utils/fetchEmergencyData'
import { EmergencyTypes } from '../../models/emergencyTypes'
import * as Icons from '../Icons/ViewIcons'
import translation from '../../translations/views.json'
import { AvailableViews } from '../../models/enums'
import Animation2 from '../Loader/Animation2'
import { useView } from '../Contexts/ViewContext'

interface EmergencyProps {
  locale: string
  deviceType: number
}

const EmergencyContent = ({
  locale,
  deviceType
}: EmergencyProps): JSX.Element => {
  const { addressData } = useRetorik()
  const [municipalPoliceNumber, setMunicipalPoliceNumber] = useState<string>('')
  const [localHospitalName, setLocalHospitalName] = useState<string>('')
  const [localHospitalNumber, setLocalHospitalNumber] = useState<string>('')
  const [poisonControlNumber, setPoisonControlNumber] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(true)
  const iconClassname = 'rf-h-16 rf-w-16'
  const subView = AvailableViews.emergency
  const { isMobile } = useView()

  useEffect(() => {
    const getData = async (): Promise<void> => {
      const data: EmergencyTypes = await fetchEmergencyData(addressData)
      if (data) {
        setMunicipalPoliceNumber(data.municipalPoliceNumber)
        setLocalHospitalName(data.localHospitalName)
        setLocalHospitalNumber(data.localHospitalNumber)
        setPoisonControlNumber(data.poisonControlNumber)
      }
      setLoading(false)
    }
    getData()
    console.log(deviceType)
  }, [addressData])
  return (
    <>
      <div
        className={`rf-flex rf-flex-col rf-items-center ${
          isMobile
            ? 'rf-justify-center rf-flex-1 rf-gap-2'
            : 'rf-justify-end rf-flex-[2_1_0%] rf-gap-9'
        }`}
      >
        <Icons.EmergencyIcon className={iconClassname} />
        <h3
          className={`${
            isMobile ? 'rf-text-3xl' : 'rf-text-4xl'
          } rf-font-bold rf-capitalize-first`}
        >
          {translation[locale]?.[subView] || translation['fr-FR'][subView]}
        </h3>
      </div>
      <div
        className='rf-w-full rf-flex rf-flex-col rf-items-center rf-flex-[4_1_0%] rf-justify-evenly'
        style={{
          background: isMobile
            ? 'transparent'
            : 'transparent linear-gradient(291deg, #F2F3F6 0%, #E5E6EC 100%) 0% 0% no-repeat padding-box',
          boxShadow: isMobile
            ? ''
            : '#ffff -3px -3px 16px, rgb(0 0 0 / 25%) 0px 2px 10px 0px'
        }}
      >
        {loading ? (
          <>
            <div className='rf-w-6 rf-h-6 rf-mb-16'>
              <Animation2
                color='gray'
                loaderColor='#1999b1'
                backgroundColor='transparent'
              />
            </div>
          </>
        ) : (
          <>
            <div
              className={`rf-w-full rf-grid ${
                isMobile
                  ? 'rf-grid-cols-2 rf-gap-8'
                  : 'rf-grid-cols-4 rf-divide-x'
              } `}
              style={{ padding: isMobile ? '' : '0 10vw' }}
            >
              <div className='rf-flex rf-flex-col rf-items-center rf-gap-2'>
                <p className='rf-text-xl rf-font-bold rf-uppercase'>Samu</p>
                <p className='rf-text-6xl rf-font-bold'>15</p>
              </div>
              <div
                className={`rf-flex rf-flex-col rf-items-center ${
                  isMobile ? '' : 'rf-border-l rf-border-[#C7C6C6]'
                } rf-gap-2`}
              >
                <p className='rf-text-xl rf-font-bold rf-uppercase'>Police</p>
                <p className='rf-text-6xl rf-font-bold'>17</p>
              </div>
              <div
                className={`rf-flex rf-flex-col rf-items-center ${
                  isMobile ? '' : 'rf-border-l rf-border-[#C7C6C6]'
                } rf-gap-2`}
              >
                <p className='rf-text-xl rf-font-bold rf-uppercase'>Pompiers</p>
                <p className='rf-text-6xl rf-font-bold'>18</p>
              </div>
              <div
                className={`rf-flex rf-flex-col rf-items-center ${
                  isMobile ? '' : 'rf-border-l rf-border-[#C7C6C6]'
                } rf-gap-2`}
              >
                <p className='rf-text-xl rf-font-bold rf-uppercase'>Général</p>
                <p className='rf-text-6xl rf-font-bold'>112</p>
              </div>
            </div>
            <div
              className={`rf-flex rf-items-start ${
                isMobile ? 'rf-flex-col' : 'rf-gap-12'
              } `}
            >
              <div>
                {municipalPoliceNumber && municipalPoliceNumber.length > 0 && (
                  <p className='rf-text-xl rf-py-2'>
                    Police municipale :{' '}
                    <span className='rf-font-bold'>
                      {municipalPoliceNumber}
                    </span>
                  </p>
                )}
                <p className='rf-text-xl rf-py-2'>
                  Sans abris (appel gratuit) :{' '}
                  <span className='rf-font-bold'>115</span>
                </p>
                <p className='rf-text-xl rf-py-2'>
                  Urgences européennes :{' '}
                  <span className='rf-font-bold'>118</span>
                </p>
              </div>
              <div>
                {localHospitalName && localHospitalName.length > 0 && (
                  <p className='rf-text-xl rf-py-2'>
                    Hôpital {localHospitalName} :{' '}
                    <span className='rf-font-bold'>{localHospitalNumber}</span>
                  </p>
                )}
                {poisonControlNumber && poisonControlNumber.length > 0 && (
                  <p className='rf-text-xl rf-py-2'>
                    Centre anti-poison :{' '}
                    <span className='rf-font-bold'>{poisonControlNumber}</span>
                  </p>
                )}
              </div>
            </div>
          </>
        )}
      </div>
      {!isMobile && <div className='rf-flex-1' />}
    </>
  )
}

export { EmergencyContent }
